if (!customElements.get('le-stud-size-guide')) {
  customElements.define('le-stud-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.dialog = this.querySelector('[data-le-guide-dialog]');
      this.trigger = this.querySelector('[data-le-guide-open]');
      if (!this.dialog || !this.trigger) return;
      this.ready = true;
      this.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-le-guide-open]')) this.open();
        if (event.target.closest('[data-le-guide-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => this.release());
      const scope = this.closest('.form__wrapper') || this.closest('[data-product]');
      const lengthField = scope && Array.from(scope.querySelectorAll('.select__fieldset')).find((field) => {
        const input = field.querySelector('input[name^="properties["]');
        return input && /stecker[l -]?(?:ä|ae)nge|post[ -]?length|stud[ -]?length/i.test(input.name + ' ' + (field.querySelector('.select__label')?.textContent || ''));
      });
      if (lengthField && lengthField.querySelector('popout-select')) {
        lengthField.classList.add('le-sg-length-field');
        lengthField.append(this);
      }
    }
    open() {
      if (!this.dialog?.isConnected || this.dialog.open) return;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      this.dialog.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
    }
    release() {
      if (!this.locked) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.locked = false;
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.release();
    }
  });
}


